import { AlertTriangle, Clock, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/ui/empty-state";
import { getEmptyListState } from "@/core/ui/empty-states";

export type EscalationQueueItem = {
  id: string;
  title: string;
  severity: "low" | "medium" | "high" | "critical";
  reason: string;
  recommendedAction: string;
  dueLabel?: string;
};

export function EscalationQueue({ items }: { items: EscalationQueueItem[] }) {
  if (items.length === 0) {
    return <EmptyState className="p-4" {...getEmptyListState("exceptions")} />;
  }

  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.id} className="rounded-md border border-border p-3 text-sm">
          <div className="flex items-start justify-between gap-3">
            <div className="flex gap-2">
              {item.severity === "critical" ? (
                <AlertTriangle className="mt-0.5 text-red-600" size={16} />
              ) : (
                <ShieldCheck className="mt-0.5 text-amber-600" size={16} />
              )}
              <div>
                <div className="font-medium">{item.title}</div>
                <div className="mt-1 text-muted-foreground">{item.reason}</div>
              </div>
            </div>
            <Badge variant={item.severity === "critical" || item.severity === "high" ? "bad" : "warn"}>
              {item.severity}
            </Badge>
          </div>
          <div className="mt-2 rounded-md bg-muted p-2 text-xs">{item.recommendedAction}</div>
          {item.dueLabel ? (
            <div className="mt-2 flex items-center gap-1 text-xs text-muted-foreground">
              <Clock size={13} />
              {item.dueLabel}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
